import { render, staticRenderFns } from "./ResidentStates.vue?vue&type=template&id=ae25102c&"
import script from "./ResidentStates.vue?vue&type=script&lang=js&"
export * from "./ResidentStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports